import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type OpinionFeaturesStoriesProps = {
  /** Individual article */
  cardProps: ComponentProps<typeof Card>;
  /** Index of the article in the list */
  index: number;
};

/**
 * Renders a single story card for the Opinion Features section.
 */
const OpinionFeaturesStories = ({
  cardProps,
  index,
}: OpinionFeaturesStoriesProps): React.ReactElement => {
  const variant: CardVariations = {
    kicker: {
      color: "text-gray-515",
    },
    title: {
      color: "text-gray-850",
      size: "text-base",
      extraClass: "font-lct my-1",
    },
    byline: {
      extraClass: cn("mt-2 [&_h4]:text-xs"),
      imageWidth: 32,
      imageHeight: 32,
    },
    content: {
      width: "w-full",
      updatedTimeColor: "text-red",
      updatedTimeExtraClass: "text-7xs",
    },
  };

  return (
    <div
      className={cn(
        "story border-b border-gray-175 py-3 lg:col-span-1 lg:border-none",
        {
          "lg:order-1": index < 6,
          "lg:order-3": index === 6,
          "border-none": index === 2,
        }
      )}
      data-testid="homepage-opinion-features-stories-individual-component"
    >
      <Card
        {...cardProps}
        variations={variant}
        className={cn("h-full border-gray-175", {
          "lg:border-r lg:pr-3": index < 2,
          "lg:pl-3": index > 0,
        })}
      />
    </div>
  );
};

export default OpinionFeaturesStories;
